import { constants } from "@newsela/angelou";

import fontStyleBuilder from "@/challenges/utils/fontStyleBuilder";

const neutral600 = constants.colors.ui.neutral[600];

export const possibleTokensNumberCss = {
  color: neutral600,
  ...fontStyleBuilder({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "120%",
  }),
  margin: "0 4px",
  padding: "0px",
};

export const possibleTokensTextCss = {
  color: neutral600,
  marginTop: "2px",
  ...fontStyleBuilder({
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "133%",
  }),
};

export const rewardIconCss = {
  width: "23px",
  height: "23px",
};
